"use client";
import { MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

// Оборачивает все framer-motion анимации в reducedMotion="user": при системной
// настройке prefers-reduced-motion:reduce framer сводит transform/layout-анимации к
// мгновенным (в т.ч. полноэкранный clip-path-wipe бургер-меню — ровно та категория,
// ради которой настройка существует). Hero уже на чистом CSS с собственным
// prefers-reduced-motion guard (globals.css) — эта обёртка покрывает остальное.
// Client-компонент, т.к. MotionConfig требует клиентской границы, а layout серверный.
export default function MotionProvider({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
